import { TextField } from '@fox/atoms/src/text-field/index';
import { strIsNullOrEmpty } from '@fox/atoms/utils/string';
import { useState } from 'react';
import { FormRenderMode } from '../../../form-runtime-context/contracts';
import { useFormRuntimeContext } from '../../../form-runtime-context/form-runtime-context';
import { useMuiInputQuestionStyle } from './useMuiInputQuestionStyle';

type IRenderNumberQuestionProps = {
	inEditMode: boolean;
	questionName: string;
	id: string;
	placeholder?: string;
};

export const RenderEmailQuestion = (props: IRenderNumberQuestionProps) => {
	const { inEditMode, questionName, id } = props;
	const { formRenderMode, getAnswer, answerQuestion } = useFormRuntimeContext();
	const answer = getAnswer(questionName)?.answer?.answerString;
	const sx = useMuiInputQuestionStyle(id);

	const [invalid, setInvalid] = useState(false);

	function updateAnswer(e) {
		if (formRenderMode === FormRenderMode.design) {
			return;
		}
		let value: string | undefined;
		if (strIsNullOrEmpty(e.target.value)) {
			value = undefined;
		} else {
			value = e.target.value;
		}

		const valid = e.target.validity.valid;
		answerQuestion({
			answer: {
				answerString: value
			},
			questionName: questionName,
			error: !valid ? 'Email address is invalid' : undefined
		});
		setInvalid(!valid);
	}

	return inEditMode ? null : (
		<TextField
			size="small"
			inputProps={{
				type: 'email'
			}}
			error={invalid}
			helperText={invalid ? 'Email address is invalid' : null}
			onChange={e => {
				// immediate clear of invalidity, when valid
				if (e.target.validity.valid && invalid) {
					updateAnswer(e);
				}
			}}
			onBlur={updateAnswer}
			placeholder={props.placeholder}
			defaultValue={answer}
			sx={sx}
		/>
	);
};
